<template>
  <div class="footer">
    <img class="cc" src="@/assets/imgs/cc.svg" alt="" />
    <img class="logos" src="@/assets/imgs/logos.svg" alt="" />
  </div>
</template>
